import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Context } from '.';
import routes from './routes';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { messages as ruMessages } from './locales/ru-messages';
import { messages as baMessages } from './locales/ba-messages';



const App: FC = () => {
  const { store } = useContext(Context);
  i18n.load({
    'ru': ruMessages,
    'ba': baMessages,
  })
  i18n.activate(store.lang)

  useEffect(() => {
    if (localStorage.getItem('refresh')) {
      store.checkAuth();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (store.isLoading) {
    return <div>Loading...</div>
  };

  return (
    <I18nProvider i18n={i18n}>
      <BrowserRouter>
        <Routes>
          {routes.map((route, i) => <Route key={i} {...route} />)}
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
};

export default observer(App);